<div class="container-fluid well">
    <h5>{{title}}</h5>

    <div class="row">
        <div class="col-xs-12">
            <span
                class="nlr-checkbox"
                title="Select to confirm that the plan conforms with conveyancing outcomes"
                [ngClass]="{'has-error': planConformanceAgreement | formFieldHasError}">
                <input
                    type="checkbox"
                    name="planConformanceAgreement"
                    id="planConformanceAgreement"
                    required
                    tabindex="-1"
                    [ngClass]="{active: getModel().planConformanceAgreement}"
                    [disabled]="isDisabled()"
                    [(ngModel)]="getModel().planConformanceAgreement"
                    #planConformanceAgreement="ngModel" />
                <label for="planConformanceAgreement">I confirm that this plan conforms with the intended conveyancing outcome</label>
            </span>
        </div>
    </div>
    @if (getModel().planningAuthority?.referenceMandatory) {
        <div class="row">
            <div class="col-xs-12">
                <span
                    class="nlr-checkbox"
                    title="Select to consent to the release the plan to the planning authority"
                    [ngClass]="{'has-error': planConformanceAgreement | formFieldHasError}">
                    <input
                        type="checkbox"
                        name="planReleaseConsent"
                        id="planReleaseConsent"
                        tabindex="-1"
                        [disabled]="isDisabled()"
                        [(ngModel)]="getModel().planReleaseConsent"
                        #planReleaseConsent="ngModel" />
                    <label for="planReleaseConsent">I consent to the release of this plan to the planning authority</label>
                </span>
            </div>
        </div>
    }
    @if (isDigitalOrPortalPlan()) {
        <div class="row">
            <div class="col-xs-12">
                <span
                    class="nlr-checkbox"
                    title="Select to consent plan pdf has not been modified and reflects the digital data captured"
                    [ngClass]="{'has-error': planPdfReflectsDigitalCapturedData | formFieldHasError}">
                    <input
                        type="checkbox"
                        name="planPdfReflectsDigitalCapturedData"
                        id="planPdfReflectsDigitalCapturedData"
                        required
                        tabindex="-1"
                        [disabled]="isDisabled()"
                        [(ngModel)]="getModel().planPdfReflectsDigitalCapturedData"
                        #planPdfReflectsDigitalCapturedData="ngModel" />
                    <label for="planPdfReflectsDigitalCapturedData">
                        I declare that the content of the Certified Plan Pdf has not been modified and reflects the digital data captured in the
                        NLR-Plan system.
                    </label>
                </span>
            </div>
        </div>
    }
</div>
